export const TEST_ERROR_ROUTE = "/test-error";

export function isTestErrorRouteEnabled(publicEnv?: string) {
    return publicEnv !== "production";
}

export default function TestErrorRoute(): React.JSX.Element {
    throw new Error("Test error route triggered");
}
